export default __webpack_public_path__ + "static/media/background-tree.ed4b3620.png";